module.exports = __webpack_public_path__ + "static/media/ui3.04bf51f4.jpg";